import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from 'components/Loading';
import { fetchUserSigninCallback } from 'services/auth';
import { USUARIO_LOGADO_FAS } from 'utils/consts';

export const SigninRedirect = () => {
  // PÁGINA NECESSÁRIA PARA AUTENTICAÇÃO
  const history = useHistory();
  const dispatch = useDispatch();

  const unitaryTests = useSelector(state => state.app.unitaryTests);

  useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchUserSigninCallback(history.push));
    sessionStorage.removeItem(USUARIO_LOGADO_FAS);
  }, [dispatch, history, unitaryTests]);

  return <Loading />;
};

export default SigninRedirect;
